module.exports = __webpack_public_path__ + "img/mission.a2fb841b.png";